"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.CueForm = void 0;
var react_1 = require("@xstate/react");
var React = __importStar(require("react"));
var video_context_1 = require("../context/video-context");
var selectors_1 = require("../selectors");
var CueForm = function () {
    var videoService = (0, video_context_1.useVideo)();
    var formRef = React.useRef(null);
    var currentTime = (0, react_1.useSelector)(videoService, selectors_1.selectCurrentTime);
    var isSubmittingCueNote = (0, react_1.useSelector)(videoService, selectors_1.selectIsSubmittingCueNote);
    var cueNoteVisibility = (0, react_1.useSelector)(videoService, selectors_1.selectCueNoteVisibility);
    var viewer = (0, react_1.useSelector)(videoService, selectors_1.selectViewer);
    React.useEffect(function () {
        videoService.send({
            type: 'SET_CUE_FORM_ELEM',
            cueFormElemRef: formRef
        });
    }, [formRef.current]);
    return (React.createElement("form", { className: "cueplayer-react-cue-form", ref: formRef, onFocus: function () {
            videoService.send({ type: 'TAKE_NOTE' });
        }, onBlur: function () {
            videoService.send({ type: 'CANCELLED' });
        }, onSubmit: function (e) {
            var _a, _b;
            e.preventDefault();
            var cue = {
                text: (_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.input.value,
                startTime: currentTime,
                endTime: currentTime
            };
            if (((_b = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _b === void 0 ? void 0 : _b.input.value) !== '') {
                videoService.send({
                    type: 'SUBMITTED',
                    cue: new VTTCue(cue.startTime, cue.endTime, cue.text)
                });
            }
        } },
        React.createElement("div", { className: "cueplayer-react-cue-form-input-container" },
            isSubmittingCueNote ? (React.createElement(LoadingIndicator, null)) : (React.createElement("img", { alt: viewer.name, src: viewer.avatar_url, className: "cueplayer-react-cue-form-image", width: 24, height: 24 })),
            React.createElement("input", { disabled: isSubmittingCueNote, autoComplete: "off", "aria-label": "Leave your note here (required)", placeholder: "Leave your note here...", className: "cueplayer-react-cue-form-input", id: "input", type: "text", onChange: function () {
                    videoService.send({ type: 'CHANGE' });
                }, required: true })),
        React.createElement("div", { className: "cueplayer-react-cue-form-input-actions" },
            React.createElement("div", { className: "cueplayer-react-cue-form-visibility-select" },
                React.createElement(VisibilityIcon, null),
                React.createElement("label", null,
                    React.createElement("span", { className: "cueplayer-react-sr-only" }, "Visibility"),
                    React.createElement("select", { name: "state", defaultValue: cueNoteVisibility, onChange: function (e) {
                            var state = e.target.value;
                            // @ts-ignore
                            videoService.send('TOGGLE_CUE_STATE', { visibility: state });
                        } },
                        React.createElement("option", { value: "published" }, "Everyone"),
                        React.createElement("option", { value: "draft" }, "Only me")))),
            React.createElement("button", { className: "cueplayer-react-cue-form-submit-button", disabled: isSubmittingCueNote, type: "submit" }, "Send"))));
};
exports.CueForm = CueForm;
var LoadingIndicator = function () {
    return (React.createElement("div", { className: "cueplayer-react-cue-form-loader" },
        React.createElement("svg", { height: "16", width: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { fill: "#fff" },
                React.createElement("g", { className: "nc-loop-dots-4-16-icon-f" },
                    React.createElement("circle", { cx: "3", cy: "8", fill: "#fff", r: "2" }),
                    React.createElement("circle", { cx: "8", cy: "8", r: "2" }),
                    React.createElement("circle", { cx: "13", cy: "8", fill: "#fff", r: "2" })),
                React.createElement("style", null, loaderAnimationCSS)))));
};
var loaderAnimationCSS = ".nc-loop-dots-4-16-icon-f{--animation-duration:0.8s}.nc-loop-dots-4-16-icon-f *{opacity:.4;transform:scale(.75);animation:nc-loop-dots-4-anim var(--animation-duration) infinite}.nc-loop-dots-4-16-icon-f :nth-child(1){transform-origin:3px 8px;animation-delay:-.3s;animation-delay:calc(var(--animation-duration)/-2.666)}.nc-loop-dots-4-16-icon-f :nth-child(2){transform-origin:8px 8px;animation-delay:-.15s;animation-delay:calc(var(--animation-duration)/-5.333)}.nc-loop-dots-4-16-icon-f :nth-child(3){transform-origin:13px 8px}@keyframes nc-loop-dots-4-anim{0%,100%{opacity:.4;transform:scale(.75)}50%{opacity:1;transform:scale(1)}}";
var VisibilityIcon = function () {
    return (React.createElement("svg", { "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor" },
        React.createElement("path", { d: "M10 12a2 2 0 100-4 2 2 0 000 4z" }),
        React.createElement("path", { fillRule: "evenodd", d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z", clipRule: "evenodd" })));
};
